import { render, staticRenderFns } from "./DiversificationMeasureResults.vue?vue&type=template&id=389719ef&"
import script from "./DiversificationMeasureResults.vue?vue&type=script&lang=js&"
export * from "./DiversificationMeasureResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports